import React, { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { CalendarDays, Clock, Euro, Users } from "lucide-react";

const STATUS_LABEL = {
  open: { label: "Iscrizioni aperte", cls: "bg-giallo text-viola" },
  full: { label: "Completo", cls: "bg-arancio text-viola" },
  closed: { label: "Concluso", cls: "bg-viola/10 text-viola" },
};

export default function Webinar() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    http.get("/webinars")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="container-editorial py-16 lg:py-24" data-testid="page-webinar">
      <div className="max-w-3xl">
        <span className="pill">Webinar</span>
        <h1 className="mt-4 font-display text-5xl sm:text-6xl tracking-tighter leading-[0.95]">Incontri di formazione e divulgazione.</h1>
        <p className="mt-6 text-lg text-viola/75">Momenti aperti a professionistə e persone curiosə. Ogni webinar affronta un tema in profondità, con Q&A e materiali di approfondimento.</p>
      </div>

      {loading ? (
        <p className="mt-16 text-viola/60" data-testid="webinars-loading">Caricamento…</p>
      ) : items.length === 0 ? (
        <div className="mt-16 rounded-2xl bg-lilla p-12 text-center" data-testid="webinars-empty">
          <p className="font-display text-2xl">Nessun webinar in calendario al momento.</p>
          <p className="mt-3 text-viola/70">Iscriviti alla newsletter per essere informatə sui prossimi.</p>
        </div>
      ) : (
        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((w) => {
            const st = STATUS_LABEL[w.status] || STATUS_LABEL.open;
            return (
              <article key={w.id} className="card-flat overflow-hidden !p-0" data-testid={`webinar-card-${w.id}`}>
                <div className="aspect-[16/10] overflow-hidden bg-lilla">
                  {w.image_url ? (
                    <img src={w.image_url} alt={w.title} className="h-full w-full object-cover" />
                  ) : (
                    <div className="h-full w-full bg-gradient-to-br from-lilla to-arancio/40" />
                  )}
                </div>
                <div className="p-6">
                  <span className={`pill ${st.cls}`}>{st.label}</span>
                  <h3 className="mt-3 font-display text-2xl leading-tight">{w.title}</h3>
                  <p className="mt-3 text-sm text-viola/75 line-clamp-3">{w.description}</p>
                  <div className="mt-4 space-y-1 text-sm text-viola/70">
                    <p className="flex items-center gap-2"><CalendarDays size={14} /> {w.date}{w.time ? ` · ${w.time}` : ""}</p>
                    {w.duration_minutes && <p className="flex items-center gap-2"><Clock size={14} /> {w.duration_minutes} min</p>}
                    <p className="flex items-center gap-2"><Euro size={14} /> {w.price_eur === 0 ? "Gratuito" : `${w.price_eur} €`}</p>
                    {w.seats_available !== null && w.seats_available !== undefined && (
                      <p className="flex items-center gap-2"><Users size={14} /> {w.seats_available} posti disponibili</p>
                    )}
                  </div>
                  <a
                    href={w.booking_url || "/contatti"}
                    target={w.booking_url ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    className={`mt-6 btn-primary w-full justify-center ${w.status !== "open" ? "opacity-40 pointer-events-none" : ""}`}
                    data-testid={`webinar-book-${w.id}`}
                  >
                    {w.status === "open" ? "Prenota" : w.status === "full" ? "Completo" : "Concluso"}
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
}
